module.exports = __webpack_public_path__ + "img/act-selected.29c836e6.png";